module.exports = __webpack_public_path__ + "img/pattern1.f8b3bad.svg";